var render, staticRenderFns
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=3d6f2c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6f2c28",
  null
  
)

export default component.exports